<template>
  <div class="footerMatter">
    <div class="footer-title">公司简介</div>
    <div class="footer-desc">公司名称：广州蚁群信息科技有限公司</div>
    <div class="footer-desc">公司地址：广州市天河区盈隆广场2213号</div>
    <div class="footer-desc">电话：15221195697</div>
    <div class="footer-desc">邮箱：420780598@qq.com</div>
    <img src="../assets/ewm.png" >
    <div @click="link('https://beian.miit.gov.cn')" class="copyright">版权所有：广州蚁群信息科技有限公司  粤ICP备19033705号</div>
  </div>
</template>

<script>
  export default {
    name: 'footerMatter',
    methods:{
      link(url){
        window.open(url,"_blank");
      }
    }
  }
</script>

<style scoped lang="less">
  .footerMatter{
    padding: 20px 0;
    background-color: #5E54C7;
    img{
      width: 115px;
      height: 115px;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
    }
    .footer-title{
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      line-height: 20px;
      color: #fff;
    }
    .footer-desc{
      font-size: 14px;
      font-weight: bold;
      font-weight: bold;
      text-align: center;
      color: #fff;
      margin-top: 10px;
      &:nth-child(2){
        margin-top: 20px;
      }
    }
    .copyright{
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      color: #fff;
      margin-top: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footerMatter.vue